export default __webpack_public_path__ + "static/important-547eb07d5067a039583af6d6acfe2c8a.webp";